export enum WebSocketEventType {
	WEBSOCKET_SERVICE_READY = 'WebsocketServiceReady',
}
